import { Loadable } from './loadable';

export function isLoadingOrLoaded<T>(loadable: Loadable<T> | null): boolean {
  return loadable && (loadable.isLoading || loadable.data) ? true : false;
}
